




























import { Component, Vue, Prop } from 'vue-property-decorator';
import NoDataIllustration from '../../generic/illustrations/NoData.vue';
import { trackInteractionEvent } from '../../../helpers/GTM';
import { Project, SourceVisitor } from 'ganttlab-entities';

@Component({
  components: {
    NoDataIllustration,
  },
})
export default class NoData extends Vue {
  @Prop() readonly project!: Project | null;
  @Prop() readonly sourceUrl!: string | null;
  @Prop() readonly viewGateway!: SourceVisitor<unknown> | null;

  mounted() {
    trackInteractionEvent(
      'View',
      'No data',
      this.viewGateway ? this.viewGateway.slug : undefined,
    );
  }
}
